<template>
  <div>
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> AV Prüfung </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">AV Prüfung</li>
              </ul>
            </div>
          </div>
          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row center-block">
              <div class="col-md-12">
                <div class="card mb-0">
                  <div class="card-body">
                    <div slot="header" class="clearfix text-left">
                      <h4>Zusammenfassung</h4>
                    </div>
                    <div class="text-left">
                      <p><strong>Mandant:</strong> {{ surveyResponse.customer_name }}</p>
                      <p><strong>Vertrag:</strong> {{ surveyResponse.document_url }}</p>
                      <p><strong>Bericht:</strong> <a download target="_blank" :href="downloadBaseURL + '/survey/v1/download/?filename=' + surveyResponse.report_url">{{ surveyResponse.customer_name }}_{{ surveyResponse.document_url }}.docx</a></p>
                      <p><strong>Datum:</strong> {{ surveyResponse.createdon }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { baseURL } from '@/utils/request'
export default {
  name: 'ConfirmAV',
  data() {
    return {
      pdfURL: false,
      downloadURL: '',
      loading: false,
      downloadBaseURL: baseURL
    }
  },
  props: ['surveyResponse'],
  methods: {
    showURL: function(response) {
      this.pdfURL = true
      this.downloadURL = response
    }
  }
}
</script>

<style scoped>

</style>
